/* src/pages/notifications/page-notifications.component.scss */
:host {
  display: block;
}
.table-col {
  vertical-align: middle;
}
.table-col--published {
  width: 16rem;
}
.table-col--actions {
  width: 1px;
  white-space: nowrap;
}
/*# sourceMappingURL=page-notifications.component-MOJHVPJG.css.map */
